import { createSlice } from "@reduxjs/toolkit";
import {
  addExamForms,
  getExams,
  deleteExam,
  addQuestionToExam,
  getQuestionsOfSample,deleteQuestionFromSample,
  addImageToQuestion
} from "../services/samples_services";
// ----------------------------------------------------------------------

const slice = createSlice({
  name: "samples",

  initialState: {
    isLoading: false,
    isLoadingSample: false,
    examsList: [],
    sampleId: null,
    questionsOfSampleList: [],
    questionId:null,
  },

  reducers: {
    setSampleId: (state, action) => {
      console.log(state.sampleId)
      state.sampleId = action.payload;
    },

    setQuestionId: (state, action) => {
      console.log(state.sampleId)
      state.questionId = action.payload;
    },
  },

  extraReducers: {
    //POST  ==> add new sample
    [addExamForms.fulfilled]: (state, action) => {
      state.isLoading = false;
    },
    [addExamForms.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [addExamForms.pending]: (state) => {
      state.isLoading = true;
    },

    //GET ==> get Exams

    [getExams.fulfilled]: (state, action) => {
      state.isLoadingSample = false;
      state.examsList = action.payload.data;
    },
    [getExams.rejected]: (state, action) => {
      state.isLoadingSample = false;
    },
    [getExams.pending]: (state) => {
      state.isLoadingSample = true;
    },

    //GET ==> get Exams

    [deleteExam.fulfilled]: (state, action) => {
      state.isLoading = false;
    },
    [deleteExam.rejected]: (state, action) => {
      state.isLoadingSample = false;
    },
    [deleteExam.pending]: (state) => {
      state.isLoadingSample = true;
    },

    //POST ==> add Question To Exam

    [addQuestionToExam.fulfilled]: (state, action) => {
      state.isLoading = false;
    },
    [addQuestionToExam.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [addQuestionToExam.pending]: (state) => {
      state.isLoading = true;
    },

    //GET ==> Get Questions Of Sample

    [getQuestionsOfSample.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.questionsOfSampleList = action.payload.data.questions;
    },
    [getQuestionsOfSample.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [getQuestionsOfSample.pending]: (state) => {
      state.isLoading = true;
    },

     //GET ==> Get Questions Of Sample

     [deleteQuestionFromSample.fulfilled]: (state, action) => {
      state.isLoading = false;
      
    },
    [deleteQuestionFromSample.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [deleteQuestionFromSample.pending]: (state) => {
      state.isLoading = true;
    },

     //POST ==> ADd image to question

     [addImageToQuestion.fulfilled]: (state, action) => {
      state.isLoading = false;
      
    },
    [addImageToQuestion.rejected]: (state, action) => {
      state.isLoading = false;
    },
    [addImageToQuestion.pending]: (state) => {
      state.isLoading = true;
    },

    
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setSampleId ,setQuestionId} = slice.actions;
